/* eslint-disable no-restricted-imports */
import { JsonRpcProvider } from '@ethersproject/providers';
import { RPCs } from './rpc';
export var contractAddress = '0xa82a423671379fD93f78eA4A37ABA73C019C6D3C';
var providerMainnet = new JsonRpcProvider(RPCs['1']);
var providerArbitrum = new JsonRpcProvider(RPCs['42161']);
var providerSepolia = new JsonRpcProvider(RPCs['11155111']);
var providerOptimism = new JsonRpcProvider(RPCs['10']);
var proivderBase = new JsonRpcProvider(RPCs['8453']);
export var provider = {
    '1': providerMainnet,
    '10': providerOptimism,
    '42161': providerArbitrum,
    '8453': proivderBase,
    '11155111': providerSepolia,
};
